import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { Container, Row } from 'reactstrap';

class WhitePage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			collapsed: false,
		};
	}

	onCollapse = () => {
		let active = !this.state.collapsed;
		this.setState({ collapsed: active });
	};

	render() {
		Container.propTypes = {
			fluid: PropTypes.bool,
			// applies .container-fluid class
		};

		Row.propTypes = {
			noGutters: PropTypes.bool,
		};

		return (
			<Container fluid={true} className="h-100" id="whitePage">
				<div id="main" className={this.state.collapsed ? 'collapsed' : ''}>
					<main>{this.props.children}</main>
				</div>
			</Container>
		);
	}
}

WhitePage.propTypes = {
	children: PropTypes.node.isRequired,
};

export default WhitePage;
